import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import style from './style'
import injectSheet from 'react-jss'
import { connect } from 'react-redux'
import { updateUiAction } from 'actions/uiActions'
import { updateCurrentEntityAction, checkOfflineLimitsAction } from 'actions/applicationActions'
import getTypeIconString from 'helpers/wiredDevices/getTypeIconString'
import { WIRED_DEVICE_TYPES } from 'helpers/globals'

const { CIRCLE, POLYGON, POLYLINE, RECTANGLE } = google.maps.drawing.OverlayType

const mapStateToProps = ({ ui: { highlightAddNetworkCloset } }) => {
  return {
    highlightAddNetworkCloset
  }
}

const initialState = { showDeviceList: false, showAddList: false, highlightAddNetworkCloset: false }

class AddEntityButton extends React.Component {
  constructor(props) {
    super(props)
    this.highlightTimer = null
    this.state = { ...initialState }
  }

  componentDidMount = _ =>
    window.addEventListener('click', this.windowClick)

  componentWillUnmount = _ => {
    window.removeEventListener('click', this.windowClick)
    clearTimeout(this.highlightTimer)

    if (this.props.drawingManager) this.props.drawingManager.setMap(null)
  }

  componentDidUpdate = prevProps => {
    if (this.props.highlightAddNetworkCloset != null && this.props.highlightAddNetworkCloset !== prevProps.highlightAddNetworkCloset) {
      this.setState({ showDeviceList: true, highlightAddNetworkCloset: true })

      clearTimeout(this.highlightTimer)
      this.highlightTimer = setTimeout(_ => this.setState({ highlightAddNetworkCloset: false }), 2000)
    }
  }

  windowClick = event => {
    if (this.state.showDeviceList) {
      if (this.refs.addDeviceButton.contains(event.target)) return
      this.setState({ ...initialState })
    } else if (this.state.showAddList) {
      if (this.refs.addListButton.contains(event.target)) return
      this.setState({ ...initialState })
    }
  }

  iconStack = (el, down = 7) => (
    <span className='fa-layers fa-fw' style={{ marginRight: '.5rem' }}>
      { el }
      <FontAwesomeIcon icon='circle' inverse transform={`shrink-6 down-${down} right-7`} />
      <FontAwesomeIcon icon='plus' transform={`shrink-9 down-${down} right-7`} />
    </span>
  )

  wrapClick = fun => _ => {
    this.props.updateUiAction({ measurementTool: false, drawingMeasurement: false })
    fun()
  }

  render() {
    const { iconStack, state: { showDeviceList, showAddList, highlightAddNetworkCloset }, props: { labelFn, checkOfflineLimitsAction,
      drawing, drawingManager, updateUiAction, currentEntityType, updateCurrentEntityAction, classes } } = this

    return (
      <div className={classes.topCenterButtonContainer + (drawing ? ` ${classes.blockClick}` : '')}>
        <div
          onClick={this.wrapClick(_ => checkOfflineLimitsAction('createCamera'))}
          className={classes.addCameraButton + (drawing ? ' blockClick' : '')}
        >
          { iconStack(<FontAwesomeIcon icon='video' />, 9) }
          Camera
        </div>
        <div
          onClick={_ => this.setState({ showDeviceList: !showDeviceList, showAddList: false })}
          className={classes.moreButton + (drawing ? ' blockClick' : '')}
          ref='addDeviceButton'
        >
          Devices
          <FontAwesomeIcon icon={showDeviceList ? 'chevron-up' : 'chevron-down'} className={classes.arrowIcon} />
        </div>
        { showDeviceList &&
          <div className={classes.addList} style={{ left: '13%', width: '285px' }}>
            <div
              onClick={this.wrapClick(_ => checkOfflineLimitsAction('addNetworkCloset'))}
              className={'first' + (highlightAddNetworkCloset ? ' highlight' : '')}
            >
              { iconStack(<FontAwesomeIcon icon='server' />) }
              <span>Network Closet</span>
            </div>
            { highlightAddNetworkCloset && <FontAwesomeIcon icon='long-arrow-alt-left' className={classes.highlightArrow} /> }
            <div
              onClick={this.wrapClick(_ => checkOfflineLimitsAction('addDoorController'))}
              className='double'
            >
              { iconStack(<FontAwesomeIcon icon={['far', 'microchip']} />) }
              <span>Door Access Controller</span>
            </div>
            { WIRED_DEVICE_TYPES.map(({ text, value }) =>
                <div
                  onClick={this.wrapClick(_ => checkOfflineLimitsAction('addWiredDevice', [value]))}
                  key={value}
                >
                  { iconStack(<FontAwesomeIcon icon={getTypeIconString(value)} />) }
                  <span>{text}</span>
                </div>
              )
            }
          </div>
        }
        <div
          onClick={_ => this.setState({ showAddList: !showAddList, showDeviceList: false })}
          className={classes.moreButton + (drawing ? ' blockClick' : '')}
          style={{ borderRadius: '0 .5rem .5rem 0' }}
          ref='addListButton'
        >
          More
          <FontAwesomeIcon icon={showAddList ? 'chevron-up' : 'chevron-down'} className={classes.arrowIcon} />
        </div>
        { showAddList &&
          <div className={classes.addList} style={{ right: '-5%' }}>
            <div
              onClick={_ => {
                updateUiAction({ drawingWall: true, showWallBlindspots: true })
                if (currentEntityType !== 'map' && currentEntityType !== 'camera') updateCurrentEntityAction({ type: 'map' })
              }}
            >
              { iconStack(<FontAwesomeIcon icon={['fac', 'wall']} />, 9) }
              Wall
            </div>
            <div onClick={this.wrapClick(labelFn)}>
              { iconStack(<FontAwesomeIcon icon='comment' />) }
              <span>Label</span>
            </div>
            <div onClick={this.wrapClick(_ => drawingManager.setDrawingMode(CIRCLE))}>
              { iconStack(<FontAwesomeIcon icon={['far', 'circle']} />) }
              <span>Circle</span>
            </div>
            <div onClick={this.wrapClick(_ => drawingManager.setDrawingMode(POLYGON))}>
              { iconStack(<FontAwesomeIcon icon='draw-polygon' />) }
              <span>Polygon</span>
            </div>
            <div onClick={this.wrapClick(_ => drawingManager.setDrawingMode(POLYLINE))}>
              { iconStack(<FontAwesomeIcon icon='wave-square' style={{ paddingRight: '.35rem' }} />) }
              <span>Line</span>
            </div>
            <div onClick={this.wrapClick(_ => drawingManager.setDrawingMode(RECTANGLE))}>
              { iconStack(<FontAwesomeIcon icon='vector-square' />) }
              <span>Rectangle</span>
            </div>
            <div onClick={_ => updateUiAction({ measurementTool: true, drawingMeasurement: true })}>
              { iconStack(<FontAwesomeIcon icon='ruler-combined' />, 11) }
              <span>Measurement</span>
            </div>
          </div>
        }
      </div>
    )
  }
}

export default connect(mapStateToProps, { checkOfflineLimitsAction, updateUiAction, updateCurrentEntityAction })(injectSheet(style)(AddEntityButton))



// WEBPACK FOOTER //
// ./src/components/MapComponents/AddEntityButton/index.js